import React from 'react';
import { ResizeHandleBar } from './styles';

const KEYBOARD_STEP = 10;

const ResizeHandle = ({ column, onDoubleClick, onKeyboardResize }) => {
    const handleKeyDown = (e) => {
        if (e.key === 'ArrowRight') {
            e.preventDefault();
            e.stopPropagation();
            onKeyboardResize && onKeyboardResize(column, KEYBOARD_STEP);
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            e.stopPropagation();
            onKeyboardResize && onKeyboardResize(column, -KEYBOARD_STEP);
        } else if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            onDoubleClick && onDoubleClick(column);
        }
    };

    const headerLabel = typeof column.Header === 'string' ? column.Header : column.id;
    const currentWidth = Math.round(column.totalWidth);

    return (
        <ResizeHandleBar
            // Supplies role="separator" plus the mouse/touch drag handlers.
            {...column.getResizerProps()}
            onClick={(e) => e.stopPropagation()}
            onDoubleClick={(e) => {
                    e.stopPropagation();
                    onDoubleClick && onDoubleClick(column);
                }
            }
            onKeyDown={handleKeyDown}
            tabIndex={0}
            // aria-orientation defaults to "horizontal" for role="separator";
            // a column resizer is vertical, so declare it explicitly.
            aria-orientation="vertical"
            aria-label={`Resize ${headerLabel} column. Use arrow keys to resize, Enter to auto-fit.`}
            aria-valuenow={currentWidth}
            // Without an explicit min, aria-valuemin/max default to 0/100 and the
            // pixel width reads as out of range. No aria-valuemax: no maximum
            // column width is enforced (PM-18398).
            aria-valuemin={Math.round(column.minWidth ?? 0)}
            aria-valuetext={`${currentWidth} pixels`}
            className={column.isResizing ? 'isResizing' : ''}
        />
    );
};

export default ResizeHandle;
